<template>
  <div class="flex flex-row">
    <div class="flex-grow"></div>
    <div class="flex flex-row">
      <vue-ads-pagination
        :total-items="total_items"
        :max-visible-pages="pages"
        :page="page"
        :items-per-page="9"
        class="flex flex-row"
      >
        <template slot-scope="props">
          <div
            class="hidden sm:hidden md:hidden lg:flex xl:flex text-base self-center italic"
          >
            Accommodaties {{ props.start }} tot {{ props.end }} van de
            {{ props.total }}
          </div>
        </template>

        <template slot="buttons" slot-scope="props">
          <vue-ads-page-button
            v-for="(button, key) in props.buttons"
            :key="key"
            v-bind="button"
            @page-change="pageChange(button.page)"
            class="p-2 hover:text-mi-blue-500 hover:font-extrabold text-base focus:outline-none"
            :disable-styling="true"
            :class="{
              'text-xl': button.active,
              'font-extrabold': button.active,
              'text-mi-blue-500': button.active
            }"
          />
        </template>
      </vue-ads-pagination>
    </div>
    <div class="flex-grow self-center"></div>
    <div class="flex self-center">
      <button
        class="hidden lg:block xl:block bg-gray-100 flex flex-row self-center hover:bg-mi-blue-500 text-base text-mi-blue-500 font-semibold h10 hover:text-white px-2 border border-blue-500 hover:border-transparent rounded"
        @click="addAccommodatie()"
        v-if="hasPermission('sugggest accommodatie')"
      >
        <div class="flex self-center flex-row">
          <i class="py-1 pr-1 material-icons">add_circle_outline </i>
          <p class="pt-1 pb-2">Accommodatie</p>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import "../../../node_modules/@fortawesome/fontawesome-free/css/all.css";
import "../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css";

import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";

export default {
  name: "Pagination",
  components: {
    VueAdsPagination,
    VueAdsPageButton
  },
  data() {
    return {
      pages: window.innerWidth > 768 ? 5 : 2
    };
  },
  computed: {
    total_items() {
      if (!this.$store.state.backend_data_loaded) return 0;
      return this.$store.state.backend_data.accommodaties["total_items"];
    },
    page() {
      // backend index starts on 1, component on 0
      return this.$store.state.search.page - 1;
    }
  },
  methods: {
    pageChange(page) {
      this.$store.dispatch("update_search", {
        // backend index starts on 1, component on 0
        selected: page + 1,
        filtername: "page"
      });
    },
    addAccommodatie() {
      this.$router.push({ name: "AddAccommodatie" });
    }
  }
};
</script>
